import firstValue from "../../../helpers/first.value";
import Container from "../../../components/element/container";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBModalBody } from "mdb-react-ui-kit";
import Icon from "../../../components/element/icon";
import FullModal from "../../../components/modal/full.modal";
import AgreementReaderModal from "../../../components/modal/agreement.reader.modal";
import formatNumber from "../../../helpers/format.number";


const importantInformation = [
  "Non-refundable once inspection has commenced.",
  "Certification approval is subject to inspection results.",
  "Inspection fee does not guarantee vehicle sale.",
];

export default function InspectionPaymentModal({
  open,
  consign,
  onClose,
  onConfirm,
}) {
  const { t } = useTranslation();
  const [agreed, setAgreed] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);

  const inspectionOrder = consign?.inspection_order || {};
  const fee = firstValue(
    inspectionOrder?.amount,
    inspectionOrder?.total,
    consign?.inspection_fee,
    300,
  );
  const feeLabel = `RM${formatNumber(fee)}`;
  const mileage = firstValue(consign?.odometer, consign?.product?.mileage);

  const details = [
    [
      "famicons:car-sport",
      "Vehicle",
      firstValue(consign?.product?.name, consign?.name, "-"),
    ],
    [
      "fluent-mdl2:number-field",
      "Car Plate",
      firstValue(consign?.car_plate, consign?.product?.car_plate, "-"),
    ],
    [
      "bxs:tachometer",
      "Mileage",
      mileage ? `${formatNumber(mileage)} km` : "-",
    ],
  ];

  const close = () => {
    setAgreed(false);
    setShowAgreement(false);
    onClose?.();
  };

  const handleAgreementChange = () => {
    if (agreed) {
      setAgreed(false);
      return;
    }

    setShowAgreement(true);
  };

  return (
    <>
      <FullModal
        independent
        show={open}
        close={close}
        showCloseButton
        centered
        screenSize="lg"
        className="product-action-modal reservation-modal inspection-payment-modal"
        dialogClassName="action-modal-dialog reservation-dialog"
        contentClassName="action-modal-content reservation-content"
        content={
          <MDBModalBody className="action-modal-body reservation-body">
            <h2>{t("Confirm Payment")}</h2>
            <p className="reservation-lead security-note-inline">
              <Icon
                tag="span"
                icon="solar:lock-keyhole-linear"
                className="security-lock"
              />
              {t("Once payment is complete, our team will proceed the inspection")}
            </p>

            <Container tag="div" className="reservation-details">
              {details.map(([icon, label, value]) => (
                <article className="reservation-detail" key={label}>
                  <Icon icon={icon} className="reservation-detail-icon" />
                  <span>{label}</span>
                  <p>{value}</p>
                </article>
              ))}

              <article className="reservation-detail">
                <Icon
                  icon="game-icons:auto-repair"
                  className="reservation-detail-icon"
                />
                <span>{t("Inspection Package")}</span>
                <p>{t("DCAR Certified Inspection")}</p>
              </article>

              <article className="reservation-detail">
                <Icon icon="vaadin:money" className="reservation-detail-icon" />
                <span>{t("Inspection Fees")}</span>
                <p>
                  {feeLabel} <small>(Inclusive SST)</small>
                </p>
              </article>
            </Container>

            <Container tag="div" className="reservation-divider" />
            <Container tag="div" className="reservation-important">
              <h3>{t("Important Information")}</h3>
              <ul className="reservation-terms">
                {importantInformation.map((item) => (
                  <li key={item}>{t(item)}</li>
                ))}
              </ul>

              <Container tag="div" className="reservation-agreement">
                <article className="checkbox-wrapper agreement-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      checked={agreed}
                      onChange={handleAgreementChange}
                    />
                    <span className="checkbox" />
                  </label>
                </article>
                <p className="reservation-agreement-copy">
                  {t("I have read and agree to the Inspection")}{" "}
                  <button type="button" onClick={() => setShowAgreement(true)}>
                    <u>{t("Terms & Conditions")}</u>
                  </button>
                </p>
              </Container>
            </Container>

            <button
              type="button"
              className="action-modal-primary"
              disabled={!agreed}
              onClick={() => onConfirm?.()}
            >
              {`Pay ${feeLabel} Inspection Fee`}

            </button>
          </MDBModalBody>
        }
      />

      <AgreementReaderModal
        show={showAgreement}
        type="service"
        record={consign}
        accepted={agreed}
        onAcceptedChange={setAgreed}
        onClose={() => setShowAgreement(false)}
      />
    </>
  );
}
